import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supportedLanguages, translateText } from '../../../helpers/LanguageHelper';

const currentBuild = process.env.REACT_APP_BUILD_ID;
export default function DeploymentUpdate() {
    const { pathname } = useLocation();
    const [available, setAvailable] = useState(null);
    useEffect(() => {
        if (!currentBuild) return undefined;
        let stopped = false, busy = false, request;
        const check = async () => {
            if (busy || document.hidden) return;
            busy = true;
            request = new AbortController();
            const timeout = window.setTimeout(() => request.abort(), 8000);
            try {
                const response = await fetch(`${process.env.PUBLIC_URL || ''}/version.json?check=${Date.now()}`, {
                    cache: 'no-store', signal: request.signal
                });
                if (!response.ok) return;
                const data = await response.json();
                if (!stopped && typeof data.buildId === 'string' && /^[a-z0-9-]{1,100}$/.test(data.buildId)) {
                    setAvailable(data.buildId === currentBuild ? null : data.buildId);
                }
            } catch { /* Offline or a deployment in progress must not interrupt shopping. */ }
            finally { window.clearTimeout(timeout); busy = false; }
        };
        check();
        const timer = window.setInterval(check, 60000);
        window.addEventListener('focus', check);
        document.addEventListener('visibilitychange', check);
        return () => {
            stopped = true; request?.abort(); window.clearInterval(timer);
            window.removeEventListener('focus', check);
            document.removeEventListener('visibilitychange', check);
        };
    }, []);
    useEffect(() => {
        if (!available || document.hidden) return;
        const segments = pathname.split('/').filter(Boolean);
        if (supportedLanguages.includes(segments[0])) segments.shift();
        // Other pages keep entered form/payment state until the customer chooses to update.
        if (segments.length || document.querySelector('input:focus, textarea:focus, select:focus')) return;
        try {
            if (sessionStorage.getItem('ukl-reloaded-build') === available) return;
            sessionStorage.setItem('ukl-reloaded-build', available);
        } catch { return; }
        window.location.reload();
    }, [available, pathname]);
    if (!available) return null;
    return <aside role="status" className="text-center py-2" style={{ background: '#fff9ec' }}>
        {translateText('A new version is available.')}{' '}
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => window.location.reload()}>
            {translateText('Update now')}
        </button>
    </aside>;
}
